import { TransactionOriginatorType } from '@features/transactions/enums/transactionOriginatorType'
import { TransactionOriginatorTypeGroup } from '@features/transactions/enums/transactionOriginatorTypeGroup'

import { transactionOriginatorTypeGroupToTypes } from '../../../constants/transactionOriginatorTypeGroupToTypes'

export const getOriginatorTypesFromGroup = (
  originatorTypeGroups: TransactionOriginatorTypeGroup[],
): TransactionOriginatorType[] => {
  const originatorTypes: TransactionOriginatorType[] = []

  for (const originatorTypeGroup of originatorTypeGroups) {
    originatorTypes.push(...transactionOriginatorTypeGroupToTypes[originatorTypeGroup])
  }

  return originatorTypes
}
